import { BrowserRouter, Route, Routes } from "react-router-dom";
import { BookingProvider } from "./lib/booking";
import Layout from "./components/layout/Layout";

import Home from "./pages/Home";
import Services from "./pages/Services";
import ServiceDetail from "./pages/ServiceDetail";
import Staff from "./pages/Staff";
import Portfolio from "./pages/Portfolio";
import Offers from "./pages/Offers";
import Booking from "./pages/Booking";
import NotFound from "./pages/NotFound";

export default function App() {
  return (
    <BookingProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/services/:slug" element={<ServiceDetail />} />
            <Route path="/staff" element={<Staff />} />
            <Route path="/portfolio" element={<Portfolio />} />
            <Route path="/offers" element={<Offers />} />
            <Route path="/booking" element={<Booking />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </BookingProvider>
  );
}
